import { useEffect } from 'react';
import { createContext, useContext, useState, Dispatch, SetStateAction, ReactNode } from 'react';
import Product from '../container/products/interfaces/Product';
import { INITIAL_VALUES } from '../container/products/utils/INITIAL_VALUES';
import { useStore } from './Store';

interface useContextInterface {
  searchProducts: Product[];
  setSearchProducts: Dispatch<SetStateAction<Product[]>>;
  search: Product;
  setSearch: Dispatch<SetStateAction<Product>>;
  typeSearch: boolean;
  setTypeSearch: Dispatch<SetStateAction<boolean>>;
  filterSearch: Product;
  setFilterSearch: Dispatch<SetStateAction<Product>>;
}

interface ProductsComponent {
  children: ReactNode;
}

const ProductsContext = createContext<useContextInterface>({} as useContextInterface);

export default function SearchProvider({ children }: ProductsComponent) {

  const { store } = useStore();
  const [searchProducts, setSearchProducts] = useState<Product[]>([]);
  const [search, setSearch] = useState<Product>(INITIAL_VALUES);
  const [typeSearch, setTypeSearch] = useState<boolean>(false);
  const [filterSearch, setFilterSearch] = useState<Product>(INITIAL_VALUES);

  useEffect(() => {
    if (!search.LOJA.length) {
      setSearch({ ...search, LOJA: [store] });
      setFilterSearch({ ...search, LOJA: [store] });
    }
  }, []);

  return (
    <ProductsContext.Provider value={{ searchProducts, setSearchProducts, search, setSearch, typeSearch, setTypeSearch, filterSearch, setFilterSearch }}> {children} </ProductsContext.Provider>
  )
}

export function useProducts() {
  const context = useContext<useContextInterface>(ProductsContext);
  if (!context) throw new Error("Error must be used within a Products Provider")
  const { searchProducts, setSearchProducts, search, setSearch, typeSearch, setTypeSearch, filterSearch, setFilterSearch } = context;
  return { searchProducts, setSearchProducts, search, setSearch, typeSearch, setTypeSearch, filterSearch, setFilterSearch };
}
